<script>
import Layout from "../../layout/mainLayout";
import PageHeader from "@/components/page-header";
import NavigateTo from "@/components/navigate-to";
import Loading from "@/components/table-loading";
import EditItem from "@/components/table/edit-item";
import ConfirmDelete from "@/components/table/confirm-delete-popover";
import axios from 'axios';
import {
  editItem,
  viewItem,
  deleteItem,
  onFiltered,
} from "@/helpers/crud-func";
import appConfig from "@/app.config";
/*
 *  Admins component
 */
export default {
  page: {
    title: "Admins",
    meta: [
      {
        name: "description",
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    NavigateTo,
    Loading,
    EditItem,
    ConfirmDelete,
  },
  data() {
    return {
      // page header
      title: "Admins",
      items: [],
      // crud functions
      fetchLink: appConfig.admins.list,
      deleteLink: appConfig.admins.delete,
      editRouteName: "Edit-Admin",
      viewRouteName: "View-Admin",
      componentData: [],
      // table properties
      transProps: { name: "table-list" },
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: "",
      filterOn: [],
      sortDesc: false,
      hover: true,
      isBusy: true,
      fields: [
        {
          key: "id",
          label: "id",
          sortable: true,
        },
        {
          key: "name",
          label: "Name",
        },
        {
          key: "email",
          label: "Email",
        },
        {
          key: "mobile_phone",
          label: "Phone Number",
        },
        { key: "actions", label: "Actions", sortable: false },
      ],
    };
  },
  computed: {
    rows() {
      return this.componentData.length; // Total no. of records
    },
  },
  methods: {
    async fetchComponentData() {
      let that = this;
      let url = `${that.fetchLink}`;
      that.isBusy = true;
      await axios.get(url).then(function (response) {
        that.componentData = response.data.admins;
        that.totalRows = response.data.total;
        that.currentPage = response.data.current_page;
        that.isBusy = false;
      });
    },
  },
  created() {
    this.editItem = editItem.bind(this);
    this.viewItem = viewItem.bind(this);
    this.deleteItem = deleteItem.bind(this);
    this.onFiltered = onFiltered.bind(this);
  },
  mounted() {
    this.fetchComponentData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div v-if="$can('add_admin')">
              <NavigateTo routeName="Add-Admin"></NavigateTo>
              <hr />
            </div>

            <!-- Limit & search -->
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    >
                    </b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search ..."
                      class="form-control form-control-sm ml-2"
                    >
                    </b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>

            <!-- Table -->
            <div class="mb-0">
              <b-table
                primary-key="id"
                :tbody-transition-props="transProps"
                :items="componentData"
                :fields="fields"
                :hover="hover"
                responsive="sm"
                :per-page="0"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(actions)="row">
                  <div class="d-inline" v-if="$can('view_admin')">
                    <b-button
                      size="sm"
                      @click="viewItem(row.item, $event.target, viewRouteName)"
                      class="mr-1"
                      v-b-tooltip.hover
                      title="view"
                    >
                      <i class="fas fa-eye"></i>
                    </b-button>
                  </div>
                  <EditItem
                    :row="row"
                    :routeName="editRouteName"
                    :editItem="editItem"
                    permissionName="edit_admin"
                  ></EditItem>
                  <ConfirmDelete
                    :row="row"
                    :deleteItem="deleteItem"
                    :deleteLink="deleteLink"
                    :fetchComponentData="fetchComponentData"
                    permissionName="delete_admin"
                  ></ConfirmDelete>
                </template>
              </b-table>

              <div class="table_feedback">
                <div
                  class="empty_records text-center"
                  v-if="componentData.length == 0 && !isBusy"
                >
                  <p>There are no records to show.</p>
                </div>
                <div
                  class="empty_filtered text-center"
                  v-if="rows > 0 && totalRows == 0"
                >
                  <p>There are no records matching your request.</p>
                </div>
                <div class="loading" v-if="isBusy">
                  <Loading></Loading>
                </div>
              </div>
              <!-- table_feedback -->
            </div>

            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      @input="fetchComponentData"
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
